import React from 'react';
import { Badge } from '../ui/badge';

export const CATEGORIES = [
  { value: 'administratif', labelKey: 'docComp.cat.administratif', color: 'blue' },
  { value: 'contrat', labelKey: 'docComp.cat.contrat', color: 'purple' },
  { value: 'formulaire', labelKey: 'docComp.cat.formulaire', color: 'green' },
  { value: 'personnalise', labelKey: 'docComp.cat.personnalise', color: 'orange' },
];

export const PLACEHOLDER_HINTS = {
  'employee.full_name': 'docComp.hints.empFullName',
  'employee.registration_number': 'docComp.hints.empMatricule',
  'employee.job_title': 'docComp.hints.empJobTitle',
  'employee.hire_date': 'docComp.hints.empHireDate',
  'employee.contract_type': 'docComp.hints.empContractType',
  'employee.department_name': 'docComp.hints.empDept',
  'employee.site_name': 'docComp.hints.empSite',
  'company.legal_name': 'docComp.hints.coLegal',
  'company.trade_name': 'docComp.hints.coTrade',
  'company.address_line1': 'docComp.hints.coAddr1',
  'company.city': 'docComp.hints.coCity',
  'company.postal_code': 'docComp.hints.coPostal',
  'company.phone': 'docComp.hints.coPhone',
  'company.email': 'docComp.hints.coEmail',
  'company.logo_url': 'docComp.hints.coLogo',
  'generated_at': 'docComp.hints.genAt',
  'generated_by.full_name': 'docComp.hints.genBy',
};

const COLOR_CLASSES = {
  blue: 'bg-primary/10 text-primary border-primary/40',
  purple: 'bg-purple-950/20 text-purple-400 border-purple-900/40',
  green: 'bg-green-950/20 text-green-400 border-green-900/40',
  orange: 'bg-orange-950/20 text-orange-400 border-orange-900/40',
};

export const getCategoryBadge = (category, t) => {
  const cat = CATEGORIES.find((c) => c.value === category) || CATEGORIES[0];
  return (
    <Badge variant="outline" className={`text-xs ${COLOR_CLASSES[cat.color]}`}>
      {t ? t(cat.labelKey) : cat.value}
    </Badge>
  );
};
